'use client'

import { createContext, useContext, useState } from 'react'
import type { User } from './types'

interface AuthState {
  user: User | null
  token: string | null
  login: (token: string, refreshToken: string, user: User) => void
  logout: () => void
}

export const AuthContext = createContext<AuthState>(null!)

export function useAuth(): AuthState {
  return useContext(AuthContext)
}

export function useAuthProvider(): AuthState {
  const [token, setToken] = useState<string | null>(() =>
    typeof window === 'undefined' ? null : localStorage.getItem('magen_token'),
  )
  const [user, setUser] = useState<User | null>(() => {
    if (typeof window === 'undefined') return null
    const u = localStorage.getItem('magen_user')
    return u ? (JSON.parse(u) as User) : null
  })

  function login(t: string, rt: string, u: User): void {
    setToken(t)
    setUser(u)
    localStorage.setItem('magen_token', t)
    localStorage.setItem('magen_refresh_token', rt)
    localStorage.setItem('magen_user', JSON.stringify(u))
  }

  function logout(): void {
    setToken(null)
    setUser(null)
    localStorage.removeItem('magen_token')
    localStorage.removeItem('magen_refresh_token')
    localStorage.removeItem('magen_user')
  }

  return { user, token, login, logout }
}
